export default [
    {
        path: '/cms/page/list',
        name: 'cms_page_list',
        component: () => import('@src/cms/cms-page-list'),
        meta: {
            title: 'Alle Seiten',
            role: 'ROLE_LIST_CMS_PAGE',
        },
    },
    {
        path: '/cms/page/create',
        name: 'cms_page_create',
        component: () => import('@src/cms/cms-page-create'),
        meta: {
            title: 'Seite erstellen',
            role: 'ROLE_EDIT_CMS_PAGE',
        },
    },
    {
        path: '/cms/page/edit/:id',
        name: 'cms_page_edit',
        component: () => import('@src/cms/cms-page-edit'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Seite bearbeiten',
            role: 'ROLE_EDIT_CMS_PAGE',
        },
    },
];
